(function($, window, undefined) {
	'use strict';

	/*
	 * Adiciona a classe placeholder em todos os selects
	 * Essa classe altera a cor do select 
	 * (toda vez que o valor do primeiro option do select for '' (vazio)) 
	 * para a mesma cor dos placeholders dos outros campos.
	 */
	(function() {
		'use strict';

		$('select:has(option[value=""]:first-child)').on('change', function() {
			$(this).parent().toggleClass('placeholder', $.inArray($(this).val(), ['', null]) >= 0);
		}); ///.trigger('change');
	}());

	(function() {
		'use strict';

		window.customSelect = function() {};

		window.customSelect.prototype.init = function() {
			$('select').each(function() {
				var valorSelecionado = $(this).find(':checked').text(),
					customSelect = $(this).wrap('<div class="custom-select"></div>');

				customSelect.parent().append('<span class="custom-select-label">' + valorSelecionado + '</span>');
			});

			this.onSelectInit();
		};

		window.customSelect.prototype.onSelectInit = function() {
			$('select').on('change', function() {
				var $spanSelecionado = $(this).next(),
					valorSelecionado = $(this).find(':checked').text();

				$spanSelecionado.text(valorSelecionado);
			});
		};

		var customSelect = new window.customSelect();

		customSelect.init();

	}());

	/*
	 * Preenche todos os selects de estado e cidade Common/Js/Plugins/cidades-estados.js
	 */
	(function() {
		'use strict';

		$('.estado').each(function(i, e) {
			new App.CidadesEstados({
				estado: $(this),
				cidade: $(this).closest('label').nextAll(':has(.cidade):first').find('.cidade')
			});
		});
	}());



    /**
	 * Faz as animacoes dos svg's
	 */


	if (document.getElementById("svg")) {

	        document.getElementById("svg").style.opacity = "0";
	        setTimeout(function () {

	            document.getElementById("svg").style.opacity = "1";
                    if(document.getElementById("svg")){
	                    var r = new Vivus('svg', { duration: 100, forceRender: true}, function (obj) {
	                        obj.el.classList.add('finished');
	                    });
                    }
	        }, 1000);

	}


    /**
	 * Faz as animacoes dos textos
	 */
	    
        var text = $('#defaultText').text();
        var text = text.trim();

	    $("#onTyped").typed({
	        strings: [text],
	        typeSpeed: 0,
	        contentType: 'html',
	        callback: function() {
	            setTimeout(function () {
	                $("#onTyped").siblings('.typed-cursor').css('display', 'none');
	            }, 2000);
	        },
	        preStringTyped: function() {
	            //console.log('callback for every typed string');
	        },
	        onStringTyped: function () {
	            //console.log('callback for reset');
	        },
	        resetCallback: function () {
	            //console.log('callback for reset123');
	        }
	    });


    // Add fadeInUp class only when element is visible within viewport
	    $('.animatedFadeInUp').waypoint(function () {

	        var self = this.element;
	        $(self).addClass('fadeInUp');
	    }, {
	        offset: '90%'
	    });

    /* Smooth scroll */
	$('.js-goto').on('click', function (e) {
	    if (this.hash !== "") {
	        e.preventDefault();

	        var hash = $(this).attr('href');

	        $('html, body').animate({
	            scrollTop: $(hash).offset().top - 85
	        }, 800, function () {
	            window.location.hash = hash;
	        });
	    }
	});

	/**
	 * Modal e validação do formulario de Inscricao (newsletter)
	 */
	(function () {
		'use strict';

		if ($.fn.validate) {

			$('.form-inscricao').validate({
				events: 'change keyup',
				eachInvalid: function () {
					if (!$(this).hasClass('invalid')) {
						var inputName = $(this).parents('label').find('.texto-label').text();
						$(this).addClass('invalid');
						$(this).parents('label').append('<span class="erro msg-validacao">' + inputName + ' é obrigatório</span>');
					}
				},
				eachValid: function () {
					$(this).removeClass('invalid');
					$(this).parents('label').find('.erro').remove();
				}
			});

			$('.form-inscricao').on('submit', function (event) {
				var $form = $(this);

				if (event) {
					event.preventDefault();
				}

				$.ajax({
					url: $form.attr('action'),
					type: $form.attr('method'),
					dataType: 'json',
					data: $form.serialize(),
					beforeSend: function () {
						$('<span/>', {
							'class': 'spinner-loading'
						}).appendTo('.send-button');
					},
					success: function (response) {

						$('.spinner-loading').fadeOut(300, function () {
							$(this).remove();
						});

						if (response.resultado) {
							var $popup = $('#popup-newsletter');

							var $msg = $('<p/>', {
								'class': 'message-success',
								'text': 'Obrigado por assinar nossa Newsletter.'
							});

							$popup.find('.modal-body').append($msg).slideDown(300);

							setTimeout(function () {
								$msg.fadeOut(300, function () {
									$(this).remove();
									$form[0].reset();
								});
							}, 2500);

							setTimeout(function () {
								$popup.modal('hide');
							}, 3000);
						}
					},
					error: function (error) {

						$('.spinner-loading').fadeOut(300, function () {
							$(this).remove();
						});
					}
				});

			});
		}
	}());

}(jQuery, window));